export const PAGO_MIS_CUENTAS = 41

export const DEBIT_CARD_IDS = [31,66,67,99,105,106,108]

// pago facil, rapipago, caja de pago y cobro express
export const OFFLINE_PAYMENT_METHODS = [25,26,48,51]

export const GENERIC = "generic"

export const VENTA_ONLINE_HOST_LIVE = 'ventasonline.payway.com.ar'
export const VENTA_ONLINE_HOST_SANDBOX = 'developers-ventasonline.payway.com.ar'
export const ASSETS_PATH = '/static/sforms'
export const ASSETS_URL_VENTA_ONLINE_LIVE = `https://ventasonline.payway.com.ar/api${ASSETS_PATH}`
export const ASSETS_URL_VENTA_ONLINE_SANDBOX = `https://developers-ventasonline.payway.com.ar/api${ASSETS_PATH}`

export const VISA_SB = {
    elementId : 'visa-sensory-branding',
    credit : 'visa',
    debit : 'visa-debito',
    prepaid: 'visa-prepaga',
    cfg : {
        languageCode: 'es',
        constrained: false,
        checkmark: 'checkmark',
        color: '#E4SF8',
        accessibilityText: 'Visa Sensory Branding',
        sound: true,
    },
    scriptPath: '/images/VisaSensoryBrandingSDK/visa-sensory-branding.js',
    dirLocationPath: '/images/VisaSensoryBrandingSDK'
}